// Libs
import React, { useState, useContext } from "react";
import { useObserver } from "@shoothill/core";
import { StoresContext, Stores } from "Globals/Stores";

// View models
import EmploymentDetailsViewModel from "Globals/ViewModels/FormSections/EmploymentDetails/EmploymentDetailsViewModel";
import AuditedAccountViewModel from "Globals/ViewModels/FormSections/EmploymentDetails/AuditedAccountViewModel";
import ApplicationFormViewModel from "Globals/ViewModels/ApplicationFormViewModel";

// Views
import { FileUploader } from "Globals/Views/FileUploader";

// Styles
import { Row } from "Globals/Styles/LayoutStyles";

// Types
import { UserFile } from "Globals/Models/UserFile";

interface IProps {
    employmentDetailsViewModel: EmploymentDetailsViewModel;
    applicationFormViewModel: ApplicationFormViewModel;
}

export const AuditedAccountsView: React.FC<IProps> = (props: IProps) => {
    const storesContext = useContext<Stores>(StoresContext);
    const [viewModel] = useState(() => new AuditedAccountViewModel());
    return useObserver(() => (
        <>
            <Row>
                <FileUploader
                    files={props.employmentDetailsViewModel.getAuditedAccountUserFiles}
                    text={"Please provide proof with your application"}
                    onUpload={(userFile: UserFile) => viewModel.save(userFile, props.employmentDetailsViewModel)}
                    onDelete={(userFile: UserFile) => {
                        let viewModel = props.employmentDetailsViewModel.auditedAccountViewModels.find((vm) => vm.model.fileUrl == userFile.fileUrl);
                        if (viewModel) {
                            viewModel.save(userFile, props.employmentDetailsViewModel, true);
                        }
                    }}
                    disabled={props.applicationFormViewModel.model.isSubmitted}
                />
            </Row>
        </>
    ));
};
